define 'controller/NewsletterController', ['jquery'], ($) ->
  class NewsletterController

    constructor: (@$el) ->
      _self = @

      @$inputEmail = $('.newsletter__input-field--email')
      @$input = $('.newsletter__input-field')
      @$submit = $('.newsletter__submit')

      #init
      @_validateForm()
      @_subscribe()

      @$input.on 'keydown change', =>
        setTimeout(=>
          @_validateForm()
        , 50)


    _validateForm: ->
      if @_isFormFilled() and @_isEmailValid()
        @$submit.removeAttr('disabled')
      else
        @$submit.attr('disabled', true)

    _isFormFilled: ->
      isFilled = true
      @$input.each ->
        if $(this).val().length < 1
          isFilled = false
      return isFilled

    _isEmailValid: ->
      regex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
      return regex.test(@$inputEmail.val())

    destroy: ->
      @$el.off()

    _subscribe: ->
      self = @
      email = @$inputEmail
      submit = @$submit

      $('#newsletter_subscribe').on 'submit', '#subscribe', (e) ->
        e.preventDefault()
        sendmail = email.val()
        $.kryptonite
          url: $(@).attr('action')
          type: $(@).attr('method')
          data: $(@).serialize()
          complete: ->
            $('#modalOverlay').modal('hide')
          error: (error) ->
            if(error.status == 302)
              $('#loading-overlay').remove()
              window.location.href =  '/newsletter/abonnement-confirm?email=' + btoa(unescape(encodeURIComponent(sendmail)))
            else
              #$('.bloc-newsletter-form--error-technical').show()
              submit.removeAttr('disabled')
